import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import UserLoginType from '../../../views/login/UserLoginType';

// ES6 class-style
class SignupSection extends PreLoginSessionCheck {

 isFreeTrialAllowed(){
	  	let userRole = this.getUser().getRole();  
	  	if(userRole && userRole.length > 1 && window.noFreeTrialRoles && window.noFreeTrialRoles.length > 0){
	  		return  !(~window.noFreeTrialRoles.indexOf(userRole));
	  	}

	  	//user not logged in or role not defined latter is unlikely or no suppression in window.noFreeTrialRoles
	  	return true;
	 }

  render() {
  	return(
	<section data-p-ga="" className="mtb child">
		<div className="container">
			 <h2><span>Give your child </span>timely support in Maths</h2>
			 <p><span className="hmorg">Hey</span><span className="hmblue">Math!</span> is like having the best tutor at home!</p>
			 {(() => {
				if(this.props.PLPloggedIn){
					if(this.isFreeTrialAllowed()){
						return(
							<a data-ga="Home - Give your child an Edge - Free Trial" href="#" className="r-btn big-btn" onClick={this.props.startFreeTrial}>Start your Free Trial</a>
						);
					}else{
						return(<span></span>)
					}					
				}else{
					return(
							<div className="col-sm-5 mx-auto text-center">
								<UserLoginType showSignUp={this.props.showSignUp} showNewLoginForm={this.props.showNewLoginForm} from={"Bottom"}/>
							</div>
					);
				}
			})()}
			 
			 
		</div>
	</section> 
  	);
  }
}

export default SignupSection;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/SignupSection.js